/**
 * DirectorioTipoSelect.js - Selector de tipo de negocio
 * Paso 1 al crear un nuevo negocio
 */
import React from 'react';

const tiposNegocio = [
  {
    id: 'establecimiento',
    nombre: 'Establecimiento',
    descripcion: 'Local, consultorio, tienda',
    icono: 'bi-building'
  },
  {
    id: 'proveedor',
    nombre: 'Proveedor independiente',
    descripcion: 'Trabaja por su cuenta, a domicilio',
    icono: 'bi-person-badge'
  }
];

export default function DirectorioTipoSelect({ onSelectTipo, onVolver }) {
  return (
    <div className="card">
      <div className="card-header bg-white">
        <div className="d-flex align-items-center">
          <button
            className="btn btn-link p-0 me-3 text-dark"
            onClick={onVolver}
          >
            <i className="bi bi-arrow-left fs-5"></i>
          </button>
          <h5 className="mb-0">Agregar negocio</h5>
        </div>
      </div>
      <div className="card-body">
        <p className="text-muted mb-4">
          <i className="bi bi-question-circle me-2"></i>
          ¿Qué tipo de servicio?
        </p>

        <div className="d-flex flex-column gap-3">
          {tiposNegocio.map(tipo => (
            <button
              key={tipo.id}
              className="btn btn-outline-secondary text-start p-3"
              onClick={() => onSelectTipo(tipo.id)}
              style={{ minHeight: '80px' }}
            >
              <div className="d-flex align-items-center">
                <i className={`bi ${tipo.icono} fs-3 me-3 text-primary`}></i>
                <div>
                  <h6 className="mb-1">{tipo.nombre}</h6>
                  <small className="text-muted">{tipo.descripcion}</small>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
